<template>
  <div class="row items-center no-wrap gap-xs k-menu-location__wrapper">
    <KIcon name="link" color="cool-gray-70" size="20px" />
    <span class="fs-13px fw-500 k-menu-location__name" :class="`text-${color}`">{{ name }}</span>
  </div>
</template>

<script setup>
defineOptions({ name: 'KMenuLocation' })

const props = defineProps({
  name: { type: String, required: true },
  disable: { type: Boolean, default: false },
  color: { type: String, default: 'cool-gray-100' },
})
</script>

<style lang="sass" scoped>
@import "../../styles/variables.sass"
@import "../../styles/mixins.sass"

%text-overflow
  overflow: hidden
  white-space: nowrap
  text-overflow: ellipsis

.k-menu-location
  @include element('wrapper')
    max-width: 246px
  @include element('bullet')
    min-width: 8px
    min-height: 8px
  @include element('name')
    @extend %text-overflow
</style>
